import { Box, CheckIcon, Stack, styledComponent, Typography } from '@hermes/web-components'
import useTranslateMessage from '../../../hooks/useTranslateMessage'
import { SortType } from '../../../providers/SearchProfilesPage/types'
import { MobileDetailsModal } from '../MobileDetailsModal'
import { TEST_IDS } from '../../../__tests__/testUtils/constants'

interface MobileSortByModalProps {
  isOpen: boolean
  onClose: () => void
  sorting: {
    value: SortType
    label: string
  }[]
  currentSort: SortType
  changeFilter: (key: string, value: string | number | boolean) => void
}

const StyledItem = styledComponent(Typography, { shouldForwardProp: (prop: string) => prop !== 'isSelected' })<{
  isSelected?: boolean
}>(({ theme, isSelected }) => ({
  ...theme.typography.body1,
  color: isSelected ? theme.palette.primary.main : theme.palette.text.primary,
  fontWeight: isSelected ? 500 : 400
}))

const MobileSortByModal = ({ isOpen, onClose, sorting, changeFilter, currentSort }: MobileSortByModalProps) => {
  const translate = useTranslateMessage()

  const onChangeFilter = (value: SortType) => {
    changeFilter('sortType', value)
    onClose()
  }

  return (
    <MobileDetailsModal isOpen={isOpen} onClose={onClose} heading={translate('sort_by')}>
      <Box px={2} data-testid={TEST_IDS.MOBILE_SORT_BY_MODAL}>
        {sorting.map((option) => {
          const isSelected = currentSort === option.value
          return (
            <Stack
              key={option.value}
              direction="row"
              justifyContent="space-between"
              height={40}
              onClick={() => onChangeFilter(option.value)}
            >
              <StyledItem isSelected={isSelected}>{option.label}</StyledItem>
              {isSelected && <CheckIcon sx={{ width: 15, color: 'primary.main' }} />}
            </Stack>
          )
        })}
      </Box>
    </MobileDetailsModal>
  )
}

export default MobileSortByModal
